export { default as TermBody } from './TermBody/TermBody';
export type { TermBodyProps } from './TermBody/TermBody';
export { default as PrivacyPolicy } from './PrivacyPolicy/PrivacyPolicy';
export type { PrivacyPolicyProps } from './PrivacyPolicy/PrivacyPolicy';
export { default as ReconsentLeadText } from './ReconsentLeadText/ReconsentLeadText';
export type { ReconsentLeadTextProps } from './ReconsentLeadText/ReconsentLeadText';
export { default as RequiredConsentModal } from './RequiredConsentModal/RequiredConsentModal';
export type { RequiredConsentModalProps } from './RequiredConsentModal/RequiredConsentModal';
export { default as RequiredConsentFlow } from './RequiredConsentFlow/RequiredConsentFlow';
export type { RequiredConsentFlowProps } from './RequiredConsentFlow/RequiredConsentFlow';
